import $ from 'jquery';
import _ from 'lodash';

/**
 * Video thumbnails - get video thumbnails from YouTube/Vimeo.
 *
 * Usage:
 *   const videoThumbnails = new VideoThumbnails();
 *   videoThumbnails.setup(elements);
 *
 */
export default class VideoThumbnails {
	constructor() {
		this.vimeoAPIUrl = _.template('https://vimeo.com/api/v2/video/<%= id %>.json');
		this.youtubeImageTag = _.template('<img src="https://img.youtube.com/vi/<%= id %>/0.jpg" alt="<%= alt %>">');
		this.imageTag = _.template('<img src="<%= thumbnail %>" alt="<%= alt %>">');
	}

	getVimeoThumbnail(container, videoId) {
		$.ajax({
			type: 'GET',
			url: this.vimeoAPIUrl({ id: videoId }),
			jsonp: 'callback',
			dataType: 'jsonp',
			success: (data) => {
				const alt = $(container).find('.preview').data('alt');
				const thumbnail = data[0].thumbnail_large;
				$(container).removeClass('no-preview');
				$(container).find('.preview').prepend(this.imageTag({ thumbnail, alt }));
			},
		});
	}

	getYoutubeThumbnail(container, videoId) {
		const alt = $(container).find('.preview').data('alt');
		$(container).removeClass('no-preview');
		$(container)
			.find('.preview')
			.prepend(this.youtubeImageTag({ id: videoId, alt }));
	}

	setup(elements) {
		elements = $('.' + elements);

		elements.each((i, el) => {
			const vimeoId = $(el).data('vimeo-id');
			const youtubeId = $(el).data('youtube-id');

			if (vimeoId) {
				this.getVimeoThumbnail(el, vimeoId);
			}

			if (youtubeId) {
				this.getYoutubeThumbnail(el, youtubeId);
			}
		});
	}
}
